import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { TrConfirmButtonsComponent } from './tr-confirm-buttons.component';

@NgModule({
    imports: [
        CommonModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ TrConfirmButtonsComponent ],
    declarations: [ TrConfirmButtonsComponent ],
})
export class TrConfirmButtonsModule {}
